<!--  <top-bar></top-bar>  -->

 <div style="padding-top: 0px; height:100%"> 
  <router-outlet></router-outlet>
 </div>

<bottom-bar></bottom-bar>
